// extracted by mini-css-extract-plugin
module.exports = {"root":"EmptyLibrary_root__24BrA","icon":"EmptyLibrary_icon__itimx","text":"EmptyLibrary_text__1uqvr"};